import {
  TeamProductivityResponse,
  ProductivityTrendResponse,
  AssociateProductivityResponse,
  ProductiveAppMixResponse,
  ProductivityDistributionResponse,
  ProductivityKpiCard,
} from '../../types/Manager/productivityReport.types';

import {
  BarChart3,
  Clock3,
  TrendingUp,
  TrendingDown,
  Users,
} from 'lucide-react';

export const productivityKpiCards: ProductivityKpiCard[] = [
  {
    title: 'Overall Productivity',
    value: 65.69,
    unit: '%',
    sub: '+2.45% vs Previous',
    icon: <BarChart3 size={16} />,
    color: 'bg-blue-100 text-blue-600',
  },
  {
    title: 'Span Avg. Productive Time',
    value: 7.4,
    unit: 'hrs',
    sub: 'Average productive time',
    icon: <Clock3 size={16} />,
    color: 'bg-emerald-100 text-emerald-600',
  },
  {
    title: 'Above Target (≥75%)',
    value: 18,
    sub: 'Employees',
    icon: <TrendingUp size={16} />,
    color: 'bg-green-100 text-green-600',
  },
  {
    title: 'Below Target (<75%)',
    value: 10,
    sub: 'Needs attention',
    icon: <TrendingDown size={16} />,
    color: 'bg-orange-100 text-orange-600',
  },
  {
    title: 'Total Associates',
    value: 28,
    sub: 'Reporting associates',
    icon: <Users size={16} />,
    color: 'bg-violet-100 text-violet-600',
  },
];


// ---------------------------------------------------------
// Team Productivity
// ---------------------------------------------------------

export const mockTeamProductivity: TeamProductivityResponse[] = [
  {
    teamLeadCode: '610233',
    teamLeadName: 'Suparno Basu Sarbadhikary',
    currentProductivity: 65.69,
    previousProductivity: 63.24,
    changePercent: 2.45,
    trend: 'RAISE',
  },
  {
    teamLeadCode: 'SG376500',
    teamLeadName: 'Sumit Pathak',
    currentProductivity: 65.36,
    previousProductivity: 67.67,
    changePercent: -2.31,
    trend: 'DIP',
  },
  {
    teamLeadCode: 'SG377854',
    teamLeadName: 'Deepak Rohilla',
    currentProductivity: 64,
    previousProductivity: 65.17,
    changePercent: -1.17,
    trend: 'DIP',
  },
  {
    teamLeadCode: 'SG378273',
    teamLeadName: 'Shivakumar H',
    currentProductivity: 63.44,
    previousProductivity: 65.13,
    changePercent: -1.69,
    trend: 'DIP',
  },
];

// ---------------------------------------------------------
// WTD Trend
// ---------------------------------------------------------

export const mockProductivityTrend: ProductivityTrendResponse[] = [
  {
    workDate: '2026-06-22T00:00:00',
    dayName: 'Monday',
    currentProductivity: 67.39,
    previousProductivity: 66.43,
  },
  {
    workDate: '2026-06-23T00:00:00',
    dayName: 'Tuesday',
    currentProductivity: 65.35,
    previousProductivity: 65.29,
  },
  {
    workDate: '2026-06-24T00:00:00',
    dayName: 'Wednesday',
    currentProductivity: 57.35,
    previousProductivity: 65.67,
  },
  {
    workDate: '2026-06-25T00:00:00',
    dayName: 'Thursday',
    currentProductivity: 65.4,
    previousProductivity: 63.59,
  },
  {
    workDate: '2026-06-26T00:00:00',
    dayName: 'Friday',
    currentProductivity: 66.94,
    previousProductivity: 67.53,
  },
];

// ---------------------------------------------------------
// Associate Productivity
// ---------------------------------------------------------

export const mockAssociateProductivity: AssociateProductivityResponse[] = [
  {
    employeeName: 'Suparno Basu Sarbadhikary',
    employeeCode: '610233',
    teamLeadName: 'Umesh Laxman Tare',
    city: 'BANGALORE',
    shiftName: 'Morning',
    currentProductivity: 70.04,
    previousProductivity: 64.15,
    changePercent: 5.9,
    status: 'ON TRACK',
  },
  {
    employeeName: 'Gaurav Arvind Singh',
    employeeCode: 'SG413853',
    teamLeadName: 'Deepak Rohilla',
    city: 'MUMBAI',
    shiftName: 'Night',
    currentProductivity: 66.28,
    previousProductivity: 69.04,
    changePercent: -2.76,
    status: 'WATCH',
  },
  {
    employeeName: 'Saket Prajapati',
    employeeCode: '246644',
    teamLeadName: 'Deepak Rohilla',
    city: 'BANGALORE',
    shiftName: 'Night',
    currentProductivity: 66.26,
    previousProductivity: 62.87,
    changePercent: 3.39,
    status: 'ON TRACK',
  },
  {
    employeeName: 'Deepak Rohilla',
    employeeCode: 'SG377854',
    teamLeadName: 'Umesh Laxman Tare',
    city: 'MUMBAI',
    shiftName: 'Night',
    currentProductivity: 64,
    previousProductivity: 57.16,
    changePercent: 6.84,
    status: 'ON TRACK',
  },
];

// ---------------------------------------------------------
// Productive App Mix
// ---------------------------------------------------------

export const mockProductiveAppMix: ProductiveAppMixResponse[] = [
  {
    categoryName: 'Development',
    subCategoryName: 'Visual Studio Code',
    productiveHours: 2.69,
    contributionPercent: 73.69,
  },
  {
    categoryName: 'Communication',
    subCategoryName: 'Teams',
    productiveHours: 0.96,
    contributionPercent: 26.31,
  },
];

// ---------------------------------------------------------
// Productivity Distribution
// ---------------------------------------------------------

export const mockProductivityDistribution: ProductivityDistributionResponse[] =
  [
    {
      productivityRange: '60-70%',
      employeeCount: 10,
    },
  ];